export const IFRAME_HOST = 'https://gnosis-safe.io'
export const IFRAME_PATH = '/app/migrate.html'
export const MIGRATION_KEY = 'migrationFinished'
